export default __webpack_public_path__ + "static/Seo2-abb1063e808a41a53deb47f6e584333e.jpg";